<template>
  <div>
    <router-view />
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      goodsType: [],
    };
  },
  created() {
    // this.getOpenId();
    // this.getMemberInfo();
    // this.queryGoodsTypes();
  },
  mounted() {

  },
  methods: {
    // 获取openid_key
    getOpenId(){
      let openId = this.$route.query.openid_key;
      let Authorization = this.$route.query.token;
      if(openId == undefined){
        openId = window.localStorage.getItem('openId');
      }else{
        window.localStorage.setItem('openId',openId);
        window.localStorage.setItem('Authorization',Authorization);
      }
      this.setOpenIdKey(openId)
    },
    // 查询商品分类
    queryGoodsTypes() {
      this.post(this.apis.queryDataList, {
        dictType: "goods_type",
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.goodsType = response.data.dictDataList;
            response.data.dictDataList.map((i, index) => {
              this.queryGoodsList(i.dataValue, index);
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 查询商品列表接口
    queryGoodsList(type, index) {
      this.post(this.apis.queryGoodsList, {
        pageNo: 1,
        pageSize: 4,
        goodsType: type,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.goodsType[index]["list"] = response.data.list;
            //存入vuex
            this.$store.commit("setGoodsType", this.goodsType);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ...mapMutations(["setUserInfo", "setOpenIdKey"]),
  },
  computed: {
    ...mapState(["openIdKey"]),
  },
};
</script>
<style lang="less">
html {
  color: #000;
  background: #fff;
}
body,
div,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
form,
input,
textarea,
p,
th,
td {
  margin: 0;
  padding: 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
img {
  border: 0;
}
ul {
  list-style: none;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}
input,
textarea,
select {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
}
.loading {
  display: flex;
  align-items: center;
  width: 200px;
  margin: 0 auto;
  p {
    padding-left: 20px;
  }
}
.mint-toast.is-placemiddle{
  z-index: 2015; 
}
</style>
